export function handleAppError(error: any) {
  console.log("🔴 Caught Error:", error);

  if (typeof error === "string") {
    return error;
  }

  let message = "Something went wrong. Please try again.";

  // ✅ Firebase Auth Errors
  if (error?.code && error.code.startsWith("auth/")) {
    switch (error.code) {
      case "auth/invalid-credential":
      case "auth/wrong-password":
        message = "Invalid email or password.";
        break;
      case "auth/user-not-found":
        message = "No account found with this email.";
        break;
      case "auth/email-already-in-use":
        message = "This email is already registered.";
        break;
      case "auth/too-many-requests":
        message = "Too many attempts. Please wait and try again.";
        break;
      case "auth/network-request-failed":
        message = "Network error. Please check your connection.";
        break;
      default:
        message = "Authentication failed. Please try again.";
    }
  }

  // ✅ Axios / API Errors
  else if (error?.response) {
    const { status, data } = error.response;

    if (data?.message) {
      message = data.message; // Main API message
    }

    // If payload contains field-specific errors (like password)
    if (Array.isArray(data?.payload) && data.payload.length > 0) {
      const fieldErrors = data.payload
        .map((p: any) => (p.errors ? p.errors.join(", ") : ""))
        .filter(Boolean)
        .join(" ");
      if (fieldErrors) message = fieldErrors;
    }

    // Fallback based on status
    if (!message) {
      switch (status) {
        case 400:
          message = "Invalid request. Please check your input.";
          break;
        case 401:
          message = "Unauthorized. Please log in again.";
          break;
        case 403:
          message = "You do not have permission to perform this action.";
          break;
        case 404:
          message = "Requested resource not found.";
          break;
        case 500:
          message = "Server error. Please try again later.";
          break;
        default:
          message = "An unexpected error occurred.";
      }
    }
  } else if (error?.message) {
    message = error?.message;
  }

  // ✅ Network / Timeout Errors
  else if (error?.message === "Network Error") {
    message = "Network error. Please check your internet connection.";
  } else if (error?.code === "ECONNABORTED") {
    message = "Request timed out. Please try again.";
  }

  // ✅ Generic JS Error
  else if (error instanceof Error) {
    message = error.message || message;
  }

  return message;
}
